export function filterScroll() {
    window.addEventListener('load', () => {        
        const buttons = document.querySelectorAll('.sidebar__nav-list button');
        const grid = document.querySelector('.articles');

        if (!buttons.length || !grid) return;

        const iso = Isotope.data(grid);

        imagesLoaded(grid, function () {
            iso.layout();
        });

        // apply filter and update button states
        function applyFilter(filterKey) {
            const filterValue = filterKey === '*' ? '*' : '.' + filterKey;
            iso.arrange({ filter: filterValue });

            buttons.forEach(btn => {
                btn.classList.toggle('active', btn.getAttribute('data-filter') === filterValue);
            });
        }

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const filterValue = button.getAttribute('data-filter');
                const filterKey = filterValue === '*' ? '*' : filterValue.replace(/^\./, '');
                window.location.hash = filterKey;
                applyFilter(filterKey);
            });
        });

        let initialKey = window.location.hash.replace(/^#/, '') || '*';
        applyFilter(initialKey);

        window.addEventListener('hashchange', () => {
            const newKey = window.location.hash.replace(/^#/, '') || '*';
            applyFilter(newKey);
        });
    });
}